/* Regular */
import RegularArrowRightFromBracketIcon from "@repo/core/assets/icons/regular/arrow-right-from-bracket.svg";
import RegularChartLineUpIcon from "@repo/core/assets/icons/regular/chart-line-up.svg";
import RegularChevronDownIcon from "@repo/core/assets/icons/regular/chevron-down.svg";
import RegularChevronLeftIcon from "@repo/core/assets/icons/regular/chevron-left.svg";
import RegularChevronRightIcon from "@repo/core/assets/icons/regular/chevron-right.svg";
import RegularChevronUpIcon from "@repo/core/assets/icons/regular/chevron-up.svg";
import RegularCircleDollarIcon from "@repo/core/assets/icons/regular/circle-dollar.svg";
import RegularCircleQuestionIcon from "@repo/core/assets/icons/regular/circle-question.svg";
import RegularCircleUserIcon from "@repo/core/assets/icons/regular/circle-user.svg";
import RegularEllipsisIcon from "@repo/core/assets/icons/regular/ellipsis.svg";
import RegularEllipsisVerticalIcon from "@repo/core/assets/icons/regular/ellipsis-vertical.svg";
import RegularFilePenIcon from "@repo/core/assets/icons/regular/file-pen.svg";
import RegularHandHoldingDollarIcon from "@repo/core/assets/icons/regular/hand-holding-dollar.svg";
import RegularHeadsetIcon from "@repo/core/assets/icons/solid/headset.svg";
import RegularHouseIcon from "@repo/core/assets/icons/regular/house.svg";
import RegularMagnifyingGlassChartIcon from "@repo/core/assets/icons/regular/magnifying-glass-chart.svg";
import RegularMemoCircleCheckIcon from "@repo/core/assets/icons/regular/memo-circle-check.svg";
import RegularShieldKeyholeIcon from "@repo/core/assets/icons/regular/shield-keyhole.svg";
import RegularRefreshIcon from "@repo/core/assets/icons/regular/refresh.svg";
import RegularPenSquareIcon from "@repo/core/assets/icons/regular/pen-square.svg";

import RegularFileInvoiceDollarIcon from "@repo/core/assets/icons/regular/file-invoice-dollar.svg";
import RegularTagIcon from "@repo/core/assets/icons/regular/tag.svg";
import RegularBarProgressIcon from "@repo/core/assets/icons/regular/bars-progress.svg";
import RegularCalendarsIcon from "@repo/core/assets/icons/regular/calendars.svg";
import RegularClipboardCheckIcon from "@repo/core/assets/icons/regular/clipboard-check.svg";
import RegularReceiptIcon from "@repo/core/assets/icons/regular/receipt.svg";
import RegularClockIcon from "@repo/core/assets/icons/regular/clock.svg";
import RegularCircleXMark from "@repo/core/assets/icons/regular/circle-xmark.svg";

import RegularCircleCheckIcon from "@repo/core/assets/icons/regular/circle-check.svg";
import RegularCalendarIcon from "@repo/core/assets/icons/regular/calendar.svg";
import RegularListIcon from "@repo/core/assets/icons/regular/list.svg";
import RegularShareIcon from "@repo/core/assets/icons/regular/share.svg";
import RegularMinusIcon from "@repo/core/assets/icons/regular/minus.svg";
import RegularPlusIcon from "@repo/core/assets/icons/regular/plus.svg";
import RegularArrowDownLineIcon from "@repo/core/assets/icons/regular/arrow-down-line.svg";
import RegularFileIcon from "@repo/core/assets/icons/regular/file.svg";
import RegularIdCardIcon from "@repo/core/assets/icons/regular/id-card.svg";
import RegularImagePortraitIcon from "@repo/core/assets/icons/regular/image-portrait.svg";
import RegularPaperClipVerticalIcon from "@repo/core/assets/icons/regular/paperclip-vertical.svg";
import RegularCircleExclamationIcon from "@repo/core/assets/icons/regular/circle-exclamation.svg";
import RegularTrashIcon from "@repo/core/assets/icons/regular/trash.svg";
import RegularArrowUpRightFromSquareIcon from "@repo/core/assets/icons/regular/arrow-up-right-from-square.svg";
import RegularFileExportIcon from "@repo/core/assets/icons/regular/file-export.svg";

/*Solid */
import SolidArrowRightFromBracketIcon from "@repo/core/assets/icons/solid/arrow-right-from-bracket.svg";
import SolidBadgeCheckIcon from "@repo/core/assets/icons/solid/badge-check.svg";
import SolidCaretDownIcon from "@repo/core/assets/icons/solid/caret-down.svg";
import SolidCaretUpIcon from "@repo/core/assets/icons/solid/caret-up.svg";
import SolidChartLineUpIcon from "@repo/core/assets/icons/solid/chart-line-up.svg";
import SolidChevronDownIcon from "@repo/core/assets/icons/solid/chevron-down.svg";
import SolidChevronLeftIcon from "@repo/core/assets/icons/solid/chevron-left.svg";
import SolidChevronRightIcon from "@repo/core/assets/icons/solid/chevron-right.svg";
import SolidMagnifyingGlassDollarIcon from "@repo/core/assets/icons/solid/magnifying-glass-dollar.svg";
import SolidChevronUpIcon from "@repo/core/assets/icons/solid/chevron-up.svg";
import SolidCircleCheckIcon from "@repo/core/assets/icons/solid/circle-check.svg";
import SolidCircleDollarIcon from "@repo/core/assets/icons/solid/circle-dollar.svg";
import SolidCircleExclamationIcon from "@repo/core/assets/icons/solid/circle-exclamation.svg";
import SolidCircleQuestionIcon from "@repo/core/assets/icons/solid/circle-question.svg";
import SolidCircleUserIcon from "@repo/core/assets/icons/solid/circle-user.svg";
import SolidCircleXMarkIcon from "@repo/core/assets/icons/solid/circle-xmark.svg";
import SolidClockIcon from "@repo/core/assets/icons/solid/clock.svg";
import SolidEllipsisIcon from "@repo/core/assets/icons/solid/ellipsis.svg";
import SolidFilePenIcon from "@repo/core/assets/icons/solid/file-pen.svg";
import SolidHandHoldingDollarIcon from "@repo/core/assets/icons/solid/hand-holding-dollar.svg";
import SolidHeadsetIcon from "@repo/core/assets/icons/solid/headset.svg";
import SolidHouseIcon from "@repo/core/assets/icons/solid/house.svg";
import SolidLocationDotIcon from "@repo/core/assets/icons/solid/location-dot.svg";
import SolidMagnifyingGlassChartIcon from "@repo/core/assets/icons/solid/magnifying-glass-chart.svg";
import SolidMemoCircleCheckIcon from "@repo/core/assets/icons/solid/memo-circle-check.svg";
import SolidXMarkIcon from "@repo/core/assets/icons/solid/xmark.svg";
import SolidShieldKeyholeIcon from "@repo/core/assets/icons/solid/shield-keyhole.svg";
import SolidCartShoppingIcon from "@repo/core/assets/icons/solid/cart-shopping.svg";
import RegularCreditCardIcon from "@repo/core/assets/icons/regular/credit-card.svg";
import RegularStarIcon from "@repo/core/assets/icons/regular/star.svg";
import RegularFilterIcon from "@repo/core/assets/icons/regular/filter.svg";
import SolidFilterIcon from "@repo/core/assets/icons/solid/filter.svg";
import SolidEyeIcon from "@repo/core/assets/icons/solid/eye.svg";
import SolidPenSquareIcon from "@repo/core/assets/icons/solid/pen-square.svg";
import SolidSollarMagnifyingGlassIcon from "@repo/core/assets/icons/solid/dollar-magnifying-glass.svg";
import SolidCircusMinusIcon from "@repo/core/assets/icons/solid/circle-minus.svg";
import SolidCheckIcon from "@repo/core/assets/icons/solid/check.svg";
import SolidArrowLeftIcon from "@repo/core/assets/icons/solid/arrow-left.svg";
import SolidKeyIcon from "@repo/core/assets/icons/solid/key.svg";
import SolidPhoneIcon from "@repo/core/assets/icons/solid/phone.svg";
import SolidChatIcon from "@repo/core/assets/icons/solid/chat.svg";
import SolidWhatsAppIcon from "@repo/core/assets/icons/solid/whatsapp.svg";
import SolidSackDollarIcon from "@repo/core/assets/icons/solid/sack-dollar.svg";
import SolidWalletIcon from "@repo/core/assets/icons/solid/wallet.svg";
import SolidCreditCardIcon from "@repo/core/assets/icons/solid/credit-card.svg";
import SolidCircleArrowDownIcon from "@repo/core/assets/icons/solid/circle-arrow-down.svg";
import SolidCircleArrowUpIcon from "@repo/core/assets/icons/solid/circle-arrow-up.svg";
import SolidReceiptIcon from "@repo/core/assets/icons/solid/receipt.svg";
import SolidTagIcon from "@repo/core/assets/icons/solid/tag.svg";
import SolidLockIcon from "@repo/core/assets/icons/solid/lock.svg";
import SolidShopIcon from "@repo/core/assets/icons/solid/shop.svg";
import SolidShareUpIcon from "@repo/core/assets/icons/solid/share-up.svg";
import SolidSMSIcon from "@repo/core/assets/icons/solid/sms.svg";
import SolidQRCodeIcon from "@repo/core/assets/icons/solid/qrcode.svg";
import SolidPenIcon from "@repo/core/assets/icons/solid/pen.svg";
import SolidGiftIcon from "@repo/core/assets/icons/solid/gift.svg";
import SolidCameraIcon from "@repo/core/assets/icons/solid/camera.svg";

export const Regular = {
  RegularArrowRightFromBracketIcon,
  RegularChartLineUpIcon,
  RegularChevronDownIcon,
  RegularChevronLeftIcon,
  RegularChevronRightIcon,
  RegularChevronUpIcon,
  RegularCircleDollarIcon,
  RegularCircleQuestionIcon,
  RegularCircleUserIcon,
  RegularEllipsisIcon,
  RegularFilePenIcon,
  RegularHandHoldingDollarIcon,
  RegularHeadsetIcon,
  RegularHouseIcon,
  RegularMagnifyingGlassChartIcon,
  RegularMemoCircleCheckIcon,
  RegularShieldKeyholeIcon,
  RegularStarIcon,
  RegularCreditCardIcon,
  RegularFilterIcon,
  RegularRefreshIcon,
  RegularEllipsisVerticalIcon,
  RegularPenSquareIcon,
  RegularFileInvoiceDollarIcon,
  RegularTagIcon,
  RegularBarProgressIcon,
  RegularCalendarsIcon,
  RegularClipboardCheckIcon,
  RegularReceiptIcon,
  RegularClockIcon,
  RegularCircleXMark,
  RegularCircleCheckIcon,
  RegularCalendarIcon,
  RegularListIcon,
  RegularShareIcon,
  RegularMinusIcon,
  RegularPlusIcon,
  RegularArrowDownLineIcon,
  RegularFileIcon,
  RegularIdCardIcon,
  RegularImagePortraitIcon,
  RegularPaperClipVerticalIcon,
  RegularCircleExclamationIcon,
  RegularTrashIcon,
  RegularArrowUpRightFromSquareIcon,
  RegularFileExportIcon
};

export const Solid = {
  SolidArrowRightFromBracketIcon,
  SolidBadgeCheckIcon,
  SolidCaretDownIcon,
  SolidCaretUpIcon,
  SolidChartLineUpIcon,
  SolidMagnifyingGlassDollarIcon,
  SolidChevronDownIcon,
  SolidChevronLeftIcon,
  SolidChevronRightIcon,
  SolidChevronUpIcon,
  SolidCircleCheckIcon,
  SolidCircleDollarIcon,
  SolidCircleExclamationIcon,
  SolidCircleQuestionIcon,
  SolidCircleUserIcon,
  SolidCircleXMarkIcon,
  SolidClockIcon,
  SolidEllipsisIcon,
  SolidFilePenIcon,
  SolidHandHoldingDollarIcon,
  SolidHeadsetIcon,
  SolidHouseIcon,
  SolidLocationDotIcon,
  SolidMagnifyingGlassChartIcon,
  SolidMemoCircleCheckIcon,
  SolidShieldKeyholeIcon,
  SolidXMarkIcon,
  SolidCartShoppingIcon,
  SolidFilterIcon,
  SolidEyeIcon,
  SolidPenSquareIcon,
  SolidSollarMagnifyingGlassIcon,
  SolidCircusMinusIcon,
  SolidCheckIcon,
  SolidArrowLeftIcon,
  SolidKeyIcon,
  SolidSMSIcon,
  SolidPhoneIcon,
  SolidChatIcon,
  SolidWhatsAppIcon,
  SolidSackDollarIcon,
  SolidWalletIcon,
  SolidCreditCardIcon,
  SolidCircleArrowDownIcon,
  SolidCircleArrowUpIcon,
  SolidReceiptIcon,
  SolidTagIcon,
  SolidLockIcon,
  SolidShopIcon,
  SolidShareUpIcon,
  SolidQRCodeIcon,
  SolidPenIcon,
  SolidGiftIcon,
  SolidCameraIcon
};

export default { Regular, Solid };
